import { Modal } from "react-bootstrap";
import { HeaderText } from "./HeaderText";
import { Button } from "./Button";
import { showStateName, getStateEnumFromCode } from "../Data/UsState";
import { Vehicle } from "../Data/ApiTypes";

export interface ChooseVehicleModalProps {
    show:     boolean;
    setShow:  ( b: boolean ) => void;
    vehicles: Vehicle[];
    exclude?: number[];
    onSubmit: ( v: Vehicle ) => void;
    onClose: () => void;
    /** Set false when opened over another modal to avoid a double mask. */
    backdrop?: boolean | "static";
}

export function ChooseVehicleModal( props: ChooseVehicleModalProps ) {
    const { vehicles, show, setShow, onSubmit, onClose, exclude = [], backdrop = true } = { ...props };

    function submit( v: Vehicle ) {
        onSubmit( v );
        setShow( false );
    }
    const filtered = vehicles.filter( v => !exclude.includes( v.vehicleId ) );
    const etc = vehicles.length !== 0 && filtered.length === 0;
    return <Modal show={show} onHide={onClose} centered backdrop={backdrop}>
        <Modal.Header closeButton>
            <HeaderText>Add Vehicle</HeaderText>
        </Modal.Header>
        <Modal.Body>
            <div className="text-secondary p-2">
                {vehicles.length === 0 && <>You haven't added any vehicles</>}
                {etc && <>You've already added all of your vehicles</>}
            </div>
            <div className="d-flex flex-column gap-2">
                {filtered.map( v =>
                    <Button key={v.vehicleId} className="w-100 text-start p-3" onClick={ () => submit( v ) }>
                        <div className="gap-1" style={{
                                display: "grid",
                                alignItems: "center", /* color make model */
                                gridTemplateColumns: "min-content 1fr auto"
                            }}>
                            <div className="rounded-2 border border-secondary me-2"
                                style={{ height: "32px", width: "32px", backgroundColor: v.color }} />

                            <div style={{ display: "grid", alignItems: "center", gridTemplateRows: "auto auto" }}>
                                <div className="fw-bold d-flex flex-column gap-1">
                                    {v.make} {v.model}
                                </div>
                                <div>
                                    {showStateName( getStateEnumFromCode( v.stateCode )! )} {v.licensePlateNumber}
                                </div>
                            </div>
                        </div>
                    </Button> )}
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button type="button" className="w-100" onClick={() => setShow( false )}>
                Cancel
            </Button>
        </Modal.Footer>
    </Modal>;
}